<template>
    <div class="vehicles">
        <h1>{{ $t("Vehicles") }}</h1>
        <p>{{ $t("Details of the vehicles you are bringing with you.") }}</p>
        <table v-if="getVehicles.length" cellpadding="2" cellspacing="2" class="table">
            <tbody>
                <tr>
                    <th>{{ $t("Make") }}</th>
                    <th>{{ $t("Model") }}</th>
                    <th>{{ $t("Reg No") }}</th>
                    <th class="actions"></th>
                </tr>
                <tr v-for="(vehicle,index) in getVehicles" :key="index">
                    <td> {{vehicle.Make}} </td>
                    <td> {{vehicle.Model}} </td>
                    <td> {{vehicle.Registration}} </td>
                    <td class="actions">
                        <button 
                           @click.prevent="editVehicle(index)"
                           class="button blue btn-xs"
                           >{{ $t("Edit") }}</button> 
                        <button
                           @click.prevent="deleteVehicle(index)"
                           class="button blue btn-xs"
                           >{{ $t("Delete") }}</button> </td>
                </tr>
            </tbody>
        </table>
        <div id="modalVehicle">
            <h3>
               <span v-if="dsInsert">{{ $t("Add new vehicle title") }}</span>
               <span v-else>{{ $t("Edit") }} {{ $t("vehicle") }}</span>
               
            </h3>
            <div id="newVehicle">
                  <div class="div2020-3">
                     <label for="VehicleMake">{{ $t("Make") }}<RequiredMark :isValid="isMakeValid"/></label>
                     <input 
                        type="text"
                        ref="make" 
                        v-model="addEditVehicle.Make"
                        class="inputbtn btndefault btnblock" 
                        id="VehicleMake"
                        >
                  </div>
                  <div class="div2020-3">
                     <label for="VehicleModel">{{ $t("Model") }}<RequiredMark :isValid="isModelValid"/></label>
                     <input 
                        type="text"
                        v-model="addEditVehicle.Model"
                        class="inputbtn btndefault btnblock" 
                        id="VehicleModel"
                        >
                  </div>
                  <div class="div2020-3">
                     <label for="VehicleRegistration">{{ $t("Registration") }}<RequiredMark :isValid="isRegistrationValid"/></label>
                     <input 
                        type="text"
                        v-model="addEditVehicle.Registration"
                        class="inputbtn btndefault btnblock" 
                        id="VehicleRegistration"
                        >
                  </div>
                  <p style="width:100%;text-align:right">
                     <button 
                        v-if="dsInsert" 
                        @click.prevent="insertVehicle"
                        :disabled="!isValidated"

                        href="#" class="button blue btn-xs">{{ $t("Add Vehicle") }}</button>
                     <button 
                        v-if="!dsInsert" 
                        @click.prevent="saveVehicle"
                        class="button blue btn-xs">{{ $t("Edit Vehicle") }}</button>
                  </p>
            </div>
                  <div class="continue_button">
                     <a 
                        href="#" 
                        @click.prevent=""
                        class="button blue" v-if="false">Phone me</a> &nbsp;
                     <a 
                        href="#" 
                        @click.prevent="continueToExtras"
                        class="button blue">
                        <span v-if="getVehicles.length">{{ $t("Continue") }}</span>
                        <span v-else>{{ $t("Not Bringing Vehicle") }}</span>
                        </a>
                  </div>
        </div>
    </div>
</template>
<script>
      import { mapGetters } from 'vuex';
export default {
   data() {
      return {
         addEditVehicle: {
                'Make':'',
                'Model':'',
                'Registration': '',
                },
         dsInsert: true,
         editIndex: null,
      }
   },
   methods: {
      continueToExtras() {
        this.$store.commit('CHANGE_PROGRESS_STEP',2);
        this.$router.push({name: "Extras",hash:'#appTop'});
      },
      saveVehicle(index) {
         console.log('saveVehicle');
         let obj={'data':this.addEditVehicle, 'index':this.editIndex};
         // console.log('obj',obj);
         this.$store.commit('UPDATE_VEHICLE', obj );
         this.addEditVehicle.Make='';
         this.addEditVehicle.Model='';
         this.addEditVehicle.Registration='';
         this.dsInsert=true;
      },
      editVehicle(index) {
         // this.$store.commit('ADD_VEHICLE', index );
         this.dsInsert=false;
         this.editIndex=index;
         this.addEditVehicle.Make=this.getVehicles[index].Make;
         this.addEditVehicle.Model=this.getVehicles[index].Model;
         this.addEditVehicle.Registration=this.getVehicles[index].Registration;
         this.$refs.make.focus();
         // this.$refs.make.setSelectionRange(0, this.addEditVehicle.Make.length);
         // console.log(this.getVehicles[index]);
      },
      deleteVehicle(index) {
         this.$store.commit('DELETE_VEHICLE', index );
      },
      insertVehicle() {
         this.$store.commit('ADD_VEHICLE', this.addEditVehicle );
         this.addEditVehicle.Make='';
         this.addEditVehicle.Model='';
         this.addEditVehicle.Registration='';
         this.$refs.make.focus();
      },
   },
   computed: {
      ...mapGetters([
         'getVehicles',
      ]),        

      isMakeValid() {
         return this.addEditVehicle.Make!='';
      },
      isModelValid() {
         return this.addEditVehicle.Model!='';
      },
      isRegistrationValid() {
         return this.addEditVehicle.Registration!='';
      },
      isValidated() {
         return (this.isMakeValid)
            &&(this.isModelValid)
            &&(this.isRegistrationValid);
      },
   },
  mounted() {
    console.log("Vehicles mounted");
  },
  unmounted() {
    console.log("Vehicles unmounted");
  },
  created() {
    console.log("Vehicles created");
  }
}
</script>
<style scoped>
   button {
      margin:2px;
      padding: 2px 7px;
   }
   #newVehicle {
      flex-wrap: wrap;
      display:flex;
   }
   #modalVehicle {
      margin-top: 20px;
   }

   /* 
   #modalVehicle {
      position: absolute;
      background-color:rgba(0,0,0,0.4);
      top: 0;
      left: 0;
      padding: 30px;
      width: 100%;
      height: 100%;
      display:flex;
      justify-content: center;
      align-items: center;
      flex-wrap: wrap;
      
   }
   #newVehicle {
      position: relative;
      flex-wrap: wrap;
      display:flex;
      background-color:white;
      padding: 20px;

   }
   */
   .div2020-3 {
      margin-left: 10px;
   } 
</style>
